import * as fetch from "../../common/fetch";

import type {
  ScopeCreateRequestType,
  ScopeUpdateRequestType,
  ScopeDeleteRequestType
} from "../requests/scopeRequestTypes";

import {
  ScopeGetResponseType,
  ScopeGetAllResponseType
} from "../responses/scopeResponseTypes";

const url = process.env.WIB_API_URL;

export async function getAll() {
  const response = await fetch.get(`${url}/scopes`);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as ScopeGetAllResponseType;
  }
}

export async function getById(id) {
  const response = await fetch.get(`${url}/scopes/${id}`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as ScopeGetResponseType;
  }
}

export async function create(body: ScopeCreateRequestType) {
  const response = await fetch.post(`${url}/scopes`, body);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as ScopeGetResponseType;
  }
}

export async function update(id, body: ScopeUpdateRequestType) {
  const response = await fetch.put(`${url}/scopes/${id}`, body);
  return response.ok;
}

export async function del(id, body: ScopeDeleteRequestType) {
  const response = await fetch.del(`${url}/scopes/${id}`, body);
  return response.ok;
}
